<template>
  <div>
    <v-app-bar app clipped-left color="amber">
      <v-app-bar-nav-icon @click="drawer = !drawer" />
      <router-link to="/" style="text-decoration: none;">
        <span class="title ml-3 mr-5 black--text">
          ŠGÚDŠ&nbsp;
          <span class="font-weight-light">zosuvy</span>
        </span>
      </router-link>
      <div class="flex-grow-1" />

      <v-btn v-if="!logged" to="/login">Login</v-btn>

      <v-menu v-if="logged" offset-y>
        <template v-slot:activator="{ on }">
          <v-btn color="primary" v-on="on">{{ cname }}</v-btn>
        </template>
        <v-list>
          <v-list-item @click="logout()">
            <v-list-item-title>Odhlásenie</v-list-item-title>
          </v-list-item>

          <v-list-item @click="changePassword()">
            <v-list-item-title>Zmena hesla</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      app
      clipped
      color="grey lighten-4"
      v-if="logged"
    >
      <v-list dense class="grey lighten-4">
        <v-list-item to="/">
          <v-list-item-action>
            <v-icon>mdi-home</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="grey--text">Úvod</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/users">
          <v-list-item-action>
            <v-icon>mdi-account-multiple</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="grey--text"
              >Používatelia</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/lokality">
          <v-list-item-action>
            <v-icon>mdi-map</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="grey--text">Lokality</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/body">
          <v-list-item-action>
            <v-icon>mdi-map-marker</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="grey--text">Body</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/stanice">
          <v-list-item-action>
            <v-icon>mdi-weather-pouring</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="grey--text"
              >SHMÚ Stanice</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/uzemia">
          <v-list-item-action>
            <v-icon>mdi-file-tree</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="grey--text"
              >Katastr. územia</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/public/" target="_blank">
          <v-list-item-action>
            <v-icon>mdi-earth</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="grey--text"
              >Verejná stránka</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
        <v-list-group :value="false">
          <template v-slot:activator>
            <v-list-item-title class="subtitle-1 text-uppercase"
              >Reporty</v-list-item-title
            >
          </template>
          <v-list-item to="/report/geo">
            <v-list-item-action>
              <v-icon>mdi-cube-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="grey--text">Geodézia</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/report/ink">
            <v-list-item-action>
              <v-icon>mdi-cube-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="grey--text"
                >Inklinometria</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/report/hpv">
            <v-list-item-action>
              <v-icon>mdi-cube-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="grey--text"
                >Hladiny podz. vody</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/report/hpvt">
            <v-list-item-action>
              <v-icon>mdi-cube-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="grey--text"
                >Teploty podz. vody</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>

          <v-list-item to="/report/q">
            <v-list-item-action>
              <v-icon>mdi-cube-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="grey--text"
                >Výdatnosť odv. zariadení</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>

          <v-list-item to="/report/pt">
            <v-list-item-action>
              <v-icon>mdi-cube-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="grey--text"
                >Pórové tlaky</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>

          <v-list-item to="/report/zrazky1">
            <v-list-item-action>
              <v-icon>mdi-cube-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="grey--text"
                >Zrážkové úhrny 1</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>

          <v-list-item to="/report/zrazky2">
            <v-list-item-action>
              <v-icon>mdi-cube-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="grey--text"
                >Zrážkové úhrny 2</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>

          <v-list-item to="/report/zrazky3">
            <v-list-item-action>
              <v-icon>mdi-cube-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="grey--text"
                >Počet mrazových dní</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-group :value="false">
          <template v-slot:activator>
            <v-list-item-title class="subtitle-1 text-uppercase"
              >Grafy</v-list-item-title
            >
          </template>

          <v-list-item to="/chart/monitor">
            <v-list-item-action>
              <v-icon>mdi-chart-timeline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="grey--text">
                Monitorovanie
                <br />ukazovateľov
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/chart/zrazky">
            <v-list-item-action>
              <v-icon>mdi-chart-timeline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="grey--text"
                >Monitorovanie zrážok</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/charts/hpv">
            <v-list-item-action>
              <v-icon>mdi-chart-timeline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="grey--text"
                >Hladina podzemnej vody</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/charts/hpvq">
            <v-list-item-action>
              <v-icon>mdi-chart-timeline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="grey--text">
                Výdatnosť odvodňovacích
                <br />zariadení
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/charts/geo">
            <v-list-item-action>
              <v-icon>mdi-chart-timeline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="grey--text"
                >Pohybová aktivita</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/charts/ink">
            <v-list-item-action>
              <v-icon>mdi-chart-timeline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="grey--text">
                Pohybová aktivita
                <br />vrtu/hĺbky
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/charts/komb">
            <v-list-item-action>
              <v-icon>mdi-chart-timeline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="grey--text">
                Porovnávanie
                <br />metód
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/charts/mikroniv">
            <v-list-item-action>
              <v-icon>mdi-chart-timeline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="grey--text">
                Mikromorfologické
                <br />zmeny
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/charts/stabskal">
            <v-list-item-action>
              <v-icon>mdi-chart-timeline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="grey--text"
                >Posuny blokov</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-group :value="false">
          <template v-slot:activator>
            <v-list-item-title class="subtitle-1 text-uppercase"
              >Merania</v-list-item-title
            >
          </template>

          <v-list-item v-for="mer in merania" :key="mer.label" :to="mer.path">
            <v-list-item-action>
              <v-icon>{{ mer.iconName }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="grey--text">
                {{ mer.label }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-group :value="false">
          <template v-slot:activator>
            <v-list-item-title class="subtitle-1 text-uppercase"
              >Import/Export</v-list-item-title
            >
          </template>

          <v-list-item to="/importxls">
            <v-list-item-action>
              <v-icon>mdi-file-excel</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="grey--text"
                >Import zo súboru</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/export">
            <v-list-item-action>
              <v-icon>mdi-file-export</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="grey--text"
                >Export z DB</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>

    <v-main>
      <v-container fluid class="grey lighten-4">
        <router-view />
      </v-container>
    </v-main>

    <v-snackbar v-model="snackbar" :timeout="5000" :color="snackbarColor">
      {{ alertText }}
      <v-btn text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-footer color="amber" :fixed="fixed" app>
      <div class="ml-r"></div>
      <v-spacer></v-spacer>
      <div class="mr-3">
        <a href="https://www.geology.sk/">ŠGÚDŠ</a>
        &copy; {{ new Date().getFullYear() }} v{{ version }}
      </div>
    </v-footer>

    <dialog-change-password ref="dialogPassword"></dialog-change-password>
  </div>
</template>

<script>
import DialogChangePassword from "./DialogChangePassword.vue"

export default {
  data() {
    return {
      clipped: false,
      drawer: true,
      fixed: true,
      miniVariant: false,

      alertText: "",
      snackbar: false,
      snackbarColor: "info",
      merania: [
        {
          name: "Inkp",
          label: "Inklinometria prenosná",
          path: "/merania/inkp",
          iconName: "mdi-sign-direction"
        },
        {
          name: "Inks",
          label: "Inklinometria stacionárna",
          path: "/merania/inks",
          iconName: "mdi-sign-direction"
        },
        {
          name: "PT",
          label: "Pórových tlakov",
          path: "/merania/pt",
          iconName: "mdi-wiper"
        },
        {
          name: "Dilat",
          label: "Dilatometrické - skalné bloky",
          path: "/merania/dilat",
          iconName: "mdi-slope-uphill"
        },
        {
          name: "HPV",
          label: "Hladiny podz.vody",
          path: "/merania/hpv",
          iconName: "mdi-waves"
        },
        {
          name: "Potrub",
          label: "Pr.rozm.zmien potrubia",
          path: "/merania/potrub",
          iconName: "mdi-arrow-collapse-vertical"
        },
        {
          name: "Mikroniv",
          label: "Mikromorfologické",
          path: "/merania/mikro",
          iconName: "mdi-microscope"
        },
        {
          name: "Stabskal",
          label: "Dilatometrické",
          path: "/merania/stab",
          iconName: "mdi-arrow-collapse-horizontal"
        },
        {
          name: "Geodetické",
          label: "Geodetické",
          path: "/merania/geo",
          iconName: "mdi-crosshairs-gps"
        },
        {
          name: "Q",
          label: "Prietokov",
          path: "/merania/hpvq",
          iconName: "mdi-arrow-split-horizontal"
        },
        {
          name: "PEEP",
          label: "PEE - primárne",
          path: "/merania/peep",
          iconName: "mdi-clipboard-pulse"
        },
        {
          name: "PEES",
          label: "PEE - sekundárne",
          path: "/merania/pees",
          iconName: "mdi-pulse"
        },
        {
          name: "PRN",
          label: "Povrchové reziduálne",
          path: "/merania/prna",
          iconName: "mdi-publish"
        }
      ]
    }
  },

  components: {
    DialogChangePassword
  },

  methods: {
    logout: function() {
      this.$store.commit("logout")
      this.$axios.defaults.headers.common["token"] = ""
      localStorage.clear()
      this.dashboard()
      this.$store.commit("message", "Logged out")
    },

    dashboard: function() {
      return this.$router.push("/")
    },

    changePassword: function() {
      this.$refs.dialogPassword.show()
    }
  },

  name: "Private",

  computed: {
    cname: function() {
      return this.$store.state.name
    },

    logged: function() {
      return this.$store.state.logged
    },

    alertMessage: function() {
      return this.$store.state.alert
    },

    normalMessage: function() {
      return this.$store.state.message
    },

    version: function() {
      return this.$store.state.version
    }
  },

  watch: {
    alertMessage: function(val) {
      if (val !== "") {
        this.snackbar = true
        this.alertText = val
        this.snackbarColor = "error"
        console.log("POZOR: " + val)
      }
      this.$store.commit("alert", "")
    },

    normalMessage: function(val) {
      if (val !== "") {
        this.snackbar = true
        this.alertText = val
        this.snackbarColor = "success"
        console.log("SPRÁVA: " + val)
      }
      this.$store.commit("message", "")
    }
  },

  mounted: async function() {
    await this.$store.dispatch("fetchme", this.$axios)
    console.log("mounted Private.vue")
  }
}
</script>

<style>
#keep .v-navigation-drawer__border {
  display: none;
}
.exportXLS {
  display: inline;
  cursor: pointer;
}
</style>
